import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-film",
  "use": "icon-film-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"filmIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-film\"> <title id=\"icon-film_filmIconTitle\">Film</title> <path stroke-linecap=\"round\" d=\"M16 10.087l5-1.578v7.997l-4.998-1.578\" /> <path d=\"M16 7H3v11h13z\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol